import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "performance"
const PerformanceIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <circle cx={2.76} cy={19.72} r={1.26} stroke="#61366B" />
          <circle cx={9.8} cy={12.68} r={1.26} stroke="#61366B" />
          <circle cx={14.2} cy={17.08} r={1.26} stroke="#61366B" />
          <circle cx={21.24} cy={10.04} r={1.26} stroke="#61366B" />
          <path
            d="m3.64 18.84 5.28-5.28"
            stroke="#61366B"
            strokeLinejoin="round"
          />
          <path
            d="M15.667 4.173 15.08 3l-.587 1.173-1.173.587 1.173.587.587 1.173.587-1.173 1.173-.587-1.173-.587ZM5.4 6.52v1.76M4.52 7.4h1.76"
            stroke="#61366B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="m10.68 13.56 2.64 2.64M15.08 16.2l5.28-5.28"
            stroke="#61366B"
            strokeLinejoin="round"
          />
        </svg>
      }
    </span>
  )
}
export default PerformanceIcon
